import React from "react";
import TopNavbar from "../../shares/TopNavbar";
import { PublicComplianceFooter } from "../../shares/PublicSiteChrome";

export const FORA_SIGNUP_URL = "https://gofora.net/Account/CompanyRegistration";
/** Main Fora site — free trial and product information */
export const FORA_FREE_TRIAL_URL = "https://gofora.net";

/** Shared intro — used on hub and every platform learn-more page. */
export function WhatIsForaConnectorSection({ className = "" }) {
    return (
        <section
            className={`bg-white rounded-lg shadow-sm border border-gray-100 p-6 sm:p-8 ${className}`.trim()}
        >
            <h2 className="text-xl font-bold text-gray-900 mb-3">What is Fora Connector?</h2>
            <p className="text-gray-700 leading-relaxed">
                Logiciel&apos;s integration application moves customer, product, and order data between{" "}
                <strong>Fora</strong> and the platform you select. You configure mapping, run jobs or processes, and use
                logs for each path independently.
            </p>
        </section>
    );
}

/** Wrapper for standalone / embed-friendly pages (no app navbar). */
export function LearnMoreShell({ children, title, subtitle }) {
    return (
        <div className="min-h-screen bg-gray-50 text-gray-900">
            <TopNavbar />
            <article className="mx-auto max-w-4xl px-4 py-8 sm:px-6 sm:py-10 lg:px-8">
                <header className="mb-10 border-b border-gray-200 pb-8">
                    <nav className="mb-6 text-sm">
                        <a href="/learn-more" className="text-blue-700 font-semibold hover:text-blue-800">
                            ← All platforms
                        </a>
                    </nav>
                    <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-gray-900">{title}</h1>
                    {subtitle ? <p className="mt-3 text-lg text-gray-600 max-w-3xl">{subtitle}</p> : null}
                </header>
                {children}
            </article>
        </div>
    );
}

export function ForaSignupSection() {
    return (
        <section className="rounded-lg border-2 border-blue-600 bg-blue-50 p-6 sm:p-8 mt-10">
            <h2 className="text-xl font-bold text-gray-900 mb-3">New to Fora? Create your account</h2>
            <p className="leading-relaxed mb-6 text-gray-700">
                To use the Fora Mobile Commerce Platform with Fora Connector, you need a Fora company account.
                Register on Fora&apos;s site for company setup, trial options, and credentials.
            </p>
            <a
                href={FORA_SIGNUP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center rounded-lg bg-blue-600 px-6 py-3 text-base font-bold text-white shadow hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
                Sign up for Fora — Company registration
            </a>
            <p className="mt-4 text-sm text-gray-600">
                Opens{" "}
                <a
                    href={FORA_SIGNUP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-700 underline font-medium"
                >
                    gofora.net/Account/CompanyRegistration
                </a>{" "}
                in a new tab.
            </p>
        </section>
    );
}

export function QuickBooksTrademarkSection() {
    return (
        <section className="bg-white rounded-lg shadow-sm border border-gray-100 p-6 sm:p-8 mt-10">
            <h2 className="text-lg font-bold text-gray-900 mb-2">QuickBooks trademark notice</h2>
            <p className="text-sm leading-relaxed text-gray-600">
                Use the product names <strong>QuickBooks</strong>, <strong>QuickBooks Online</strong>, and{" "}
                <strong>QuickBooks Desktop</strong> exactly as written here in customer-facing materials. Do not
                abbreviate them. Intuit and QuickBooks are registered trademarks of Intuit Inc. Used with permission.
            </p>
        </section>
    );
}

export function LearnMoreFooter() {
    return (
        <div className="mt-10 space-y-6">
            <PublicComplianceFooter />
            <p className="text-center text-sm text-gray-500">Fora Connector is provided by Logiciel, Inc.</p>
        </div>
    );
}
